(() => {
  const bbbioInitializeIvtForm = (bbbioRoot) => {
    if (bbbioRoot.dataset.bbbioInitialized === 'true') return;

    const bbbioForm = bbbioRoot.querySelector('[data-bbbio-ivt-rna-form]');
    const bbbioStatus = bbbioRoot.querySelector('[data-bbbio-ivt-status]');
    const bbbioTranscriptList = bbbioRoot.querySelector('[data-bbbio-transcript-list]');
    const bbbioAddTranscriptButton = bbbioRoot.querySelector('[data-bbbio-add-transcript]');
    const bbbioPrintButton = bbbioRoot.querySelector('[data-bbbio-ivt-print]');
    const bbbioDownloadButton = bbbioRoot.querySelector('[data-bbbio-ivt-download]');
    const bbbioContactName = bbbioRoot.querySelector('[data-bbbio-ivt-contact-name]');
    const bbbioContactEmail = bbbioRoot.querySelector('[data-bbbio-ivt-contact-email]');
    const bbbioContactPhone = bbbioRoot.querySelector('[data-bbbio-ivt-contact-phone]');
    const bbbioContactBody = bbbioRoot.querySelector('[data-bbbio-ivt-contact-body]');

    if (!bbbioForm || !bbbioStatus || !bbbioTranscriptList || !bbbioAddTranscriptButton || !bbbioPrintButton || !bbbioDownloadButton || !bbbioContactName || !bbbioContactEmail || !bbbioContactPhone || !bbbioContactBody) return;
    bbbioRoot.dataset.bbbioInitialized = 'true';

    const bbbioResetTranscriptField = (bbbioField) => {
      if (bbbioField instanceof HTMLSelectElement) {
        bbbioField.selectedIndex = 0;
      } else if (bbbioField instanceof HTMLInputElement && ['checkbox', 'radio'].includes(bbbioField.type)) {
        bbbioField.checked = false;
      } else {
        bbbioField.value = '';
      }
    };

    const bbbioUpdateTranscriptCard = (bbbioCard, bbbioIndex) => {
      const bbbioTitle = bbbioCard.querySelector('.bbbio-ivt-rna-service-form__transcript-header h3');
      const bbbioRemoveButton = bbbioCard.querySelector('.bbbio-ivt-rna-service-form__remove-transcript');
      const bbbioTitleId = `${bbbioRoot.id}-transcript-${bbbioIndex}-title`;

      bbbioCard.dataset.bbbioTranscriptIndex = String(bbbioIndex);
      bbbioCard.setAttribute('aria-labelledby', bbbioTitleId);
      if (bbbioTitle) {
        bbbioTitle.id = bbbioTitleId;
        bbbioTitle.textContent = `RNA Transcript ${bbbioIndex}`;
      }

      bbbioCard.querySelectorAll('[data-bbbio-transcript-field]').forEach((bbbioField) => {
        const bbbioKey = bbbioField.dataset.bbbioTranscriptField;
        const bbbioFieldId = `${bbbioRoot.id}-transcript-${bbbioIndex}-${bbbioKey.replaceAll('_', '-')}`;
        const bbbioLabel = bbbioCard.querySelector(`[data-bbbio-transcript-label="${bbbioKey}"]`);
        bbbioField.id = bbbioFieldId;
        bbbioField.name = `transcripts[${bbbioIndex}][${bbbioKey}]`;
        if (bbbioLabel) bbbioLabel.htmlFor = bbbioFieldId;
      });

      if (bbbioRemoveButton) {
        bbbioRemoveButton.setAttribute('aria-label', `Remove RNA Transcript ${bbbioIndex}`);
      }
    };

    const bbbioRenumberTranscripts = () => {
      bbbioTranscriptList.querySelectorAll('.bbbio-ivt-rna-service-form__transcript-card')
        .forEach((bbbioCard, bbbioIndex) => bbbioUpdateTranscriptCard(bbbioCard, bbbioIndex + 1));
    };

    bbbioAddTranscriptButton.addEventListener('click', () => {
      const bbbioTemplateCard = bbbioTranscriptList.querySelector('.bbbio-ivt-rna-service-form__transcript-card');
      if (!bbbioTemplateCard) return;

      const bbbioNewCard = bbbioTemplateCard.cloneNode(true);
      bbbioNewCard.querySelectorAll('input, select, textarea').forEach((bbbioField) => {
        bbbioResetTranscriptField(bbbioField);
        bbbioField.removeAttribute('required');
      });
      bbbioNewCard.querySelector('.bbbio-ivt-rna-service-form__remove-transcript')?.remove();

      const bbbioRemoveButton = document.createElement('button');
      bbbioRemoveButton.type = 'button';
      bbbioRemoveButton.className = 'bbbio-ivt-rna-service-form__remove-transcript';
      bbbioRemoveButton.textContent = 'Remove';
      bbbioRemoveButton.addEventListener('click', () => {
        bbbioNewCard.remove();
        bbbioRenumberTranscripts();
        bbbioAddTranscriptButton.focus();
      });

      bbbioNewCard.querySelector('.bbbio-ivt-rna-service-form__transcript-header')?.appendChild(bbbioRemoveButton);
      bbbioTranscriptList.appendChild(bbbioNewCard);
      bbbioRenumberTranscripts();
      bbbioNewCard.querySelector('.bbbio-ivt-rna-service-form__transcript-header h3')?.focus();
    });

    const bbbioAddValue = (bbbioData, bbbioKey, bbbioValue) => {
      if (Object.prototype.hasOwnProperty.call(bbbioData, bbbioKey)) {
        bbbioData[bbbioKey] = Array.isArray(bbbioData[bbbioKey])
          ? [...bbbioData[bbbioKey], bbbioValue]
          : [bbbioData[bbbioKey], bbbioValue];
      } else {
        bbbioData[bbbioKey] = bbbioValue;
      }
    };

    const bbbioCollectData = () => {
      const bbbioData = {};
      new FormData(bbbioForm).forEach((bbbioValue, bbbioKey) => {
        const bbbioIsSystemField = bbbioKey.startsWith('contact[')
          || ['form_type', 'utf8', 'h-captcha-response', 'g-recaptcha-response'].includes(bbbioKey);
        if (bbbioIsSystemField) return;

        if (bbbioValue instanceof File) {
          if (bbbioValue.name) bbbioAddValue(bbbioData, bbbioKey, bbbioValue.name);
          return;
        }

        bbbioAddValue(bbbioData, bbbioKey, bbbioValue);
      });
      return bbbioData;
    };

    bbbioPrintButton.addEventListener('click', () => window.print());

    bbbioDownloadButton.addEventListener('click', () => {
      const bbbioBlob = new Blob([JSON.stringify(bbbioCollectData(), null, 2)], { type: 'application/json' });
      const bbbioUrl = URL.createObjectURL(bbbioBlob);
      const bbbioLink = document.createElement('a');
      bbbioLink.href = bbbioUrl;
      bbbioLink.download = 'ivt-rna-synthesis-service-request.json';
      document.body.appendChild(bbbioLink);
      bbbioLink.click();
      bbbioLink.remove();
      URL.revokeObjectURL(bbbioUrl);
    });

    bbbioForm.addEventListener('submit', (bbbioEvent) => {
      if (!bbbioForm.checkValidity()) {
        bbbioEvent.preventDefault();
        bbbioForm.reportValidity();
        bbbioStatus.hidden = false;
        bbbioStatus.dataset.bbbioState = 'error';
        bbbioStatus.textContent = 'Complete all required fields before submitting the request.';
        bbbioStatus.focus();
        return;
      }

      bbbioContactName.value = bbbioForm.elements.customer_name.value;
      bbbioContactEmail.value = bbbioForm.elements.email.value;
      bbbioContactPhone.value = bbbioForm.elements.phone.value;
      bbbioContactBody.value = `IN VITRO TRANSCRIPTION RNA SYNTHESIS SERVICE REQUEST\n\n${JSON.stringify(bbbioCollectData(), null, 2)}`;
      bbbioStatus.hidden = false;
      bbbioStatus.dataset.bbbioState = 'success';
      bbbioStatus.textContent = 'Submitting your request securely…';
    });

    bbbioRenumberTranscripts();
  };

  document.querySelectorAll('[data-bbbio-ivt-rna-service-form]').forEach(bbbioInitializeIvtForm);
})();
